let _ = t => t,
  _t;
import _styled from "styled-components";
/* eslint-disable conversations/no-dynamic-i18n */
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { GREAT_WHITE, EERIE } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuButton = styled.button.withConfig({
  displayName: "NavViewLinkActions__MenuButton",
  componentId: "sc-1islu9g-0"
})(["position:absolute;display:inline-flex;flex:none;width:20px;height:26px;top:4px;right:2px;border:none;border-radius:3px;background-color:transparent;justify-content:center;align-items:center;padding:0;opacity:0;transition:background-color 150ms ease;:hover{background-color:", ";}"], GREAT_WHITE);
const NavViewLinkActions = ({
  actions
}) => {
  const DropdownButton = ({
    onClick
  }) => {
    return /*#__PURE__*/_jsx(MenuButton, {
      onClick: onClick,
      "data-test-id": "nav-view-link-actions-dropdown",
      children: /*#__PURE__*/_jsx(_StyledUIIcon, {
        name: "ellipses",
        size: 22
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      })
    });
  };
  DropdownButton.displayName = 'DropdownButton';
  return /*#__PURE__*/_jsx(UIDropdown, {
    closeOnTargetLeave: true,
    Button: DropdownButton,
    placement: "right bottom",
    children: /*#__PURE__*/_jsx(UIList, {
      children: actions.map(({
        disabled,
        onClick,
        disabledText,
        buttonText,
        testId
      }) => /*#__PURE__*/_jsx(UITooltip, {
        title: I18n.text(disabledText),
        disabled: !disabled,
        placement: "right",
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: onClick,
          disabled: disabled,
          "data-test-id": testId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonText
          })
        })
      }, testId))
    })
  });
};
NavViewLinkActions.displayName = 'NavViewLinkActions';
export default NavViewLinkActions;
var _StyledUIIcon = _styled(UIIcon)(_t || (_t = _`
            transform: rotate(90deg);
            height: 19px;
            color: ${0};
          `), EERIE);